import { checkoutParcelFlowStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateCheckoutParcelTree = {
  name: "updateCheckoutParcelTree" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    checkoutParcelFlowSteps: checkoutParcelFlowStepArraySchema,
  }),
  output: z.null(),
};
